let searchFormEl = document.querySelector('#searchForm');
let inputText = searchFormEl.querySelector('#query').textContent;
let supportContentWrapperEl = document.querySelector('.support__content-wrapper');
let asideWrapperEl = document.querySelector('aside.support__sidebar');
let supportMessagesEl = supportContentWrapperEl.querySelector('.support__content-messages');
let resultsWrapper = supportContentWrapperEl.querySelector('.support__search-results');
let sidebarLinks = document.querySelectorAll('.support__sidebar a');
let supportSectionEls = document.querySelectorAll('.support__content--rendered');
let queryTerm;
let categoryId;


const endpoint = 'https://davincivaporizer.zendesk.com/api/v2/help_center/articles/search.json?';

const endpoints = {
    search: 'https://davincivaporizer.zendesk.com/api/v2/help_center/articles/search.json?',
    categories: 'https://davincivaporizer.zendesk.com/api/v2/help_center/categories.json?',
    single_category: `https://davincivaporizer.zendesk.com/api/v2/help_center/en-us/categories/${ categoryId }/articles?`
}

let req = new Request(endpoint, {
    method: 'GET',
    mode: 'cors'
});

/// hide loading message
document.addEventListener('DOMContentLoaded', function(){
    setTimeout(function(){
        supportMessagesEl.classList.toggle('is-hidden');
        supportContentWrapperEl.querySelector('.support__section-main').classList.toggle('is-visible');
        asideWrapperEl.classList.add('is-visible');
    }, 2500);
});


// search event 
searchFormEl.addEventListener('submit', function(e){
    e.preventDefault();
    if ( e.target['query'].value === '') {
        //console.log('are you kidding me??');
        e.target.classList.add('submit--error')
    } else {
        queryTerm = e.target['query'].value.trim();
        getSearchResults(queryTerm);
    }
});

// get search results | need to improve the error detection here
async function getSearchResults(query){
    let searchFetch = await fetch(endpoints.search + new URLSearchParams({ query: query }));
    let resultJson = await searchFetch.json();

    if (resultJson.results.length === 0) {
        // console.log("Search is empty");
        let searchNoReturnEl = document.createElement('p');
        searchNoReturnEl.setAttribute('class','query-no-return');
        searchNoReturnEl.textContent = "Your search query returned no results."

        supportMessagesEl.insertAdjacentElement('beforeend',searchNoReturnEl);
    } else {
        //return console.log(resultJson);
        await renderSearchResults(resultJson);
    }
}

// render results when we have a valid one
async function renderSearchResults(searchResultJson) {
    // console.log(searchResultJson.results);
    // clear the results container - coud be better separate this in a function
    let resultsArr = [];
    resultsArr = searchResultJson.results;
    
    // remove elements from view
    document.querySelector('.support__categories').classList.remove('is-visible');
    resultsWrapper.classList.remove('is-visible');
    //clear inside the result section
    // resultsWrapper.textContent = "";
    let contentSections = supportContentWrapperEl.querySelectorAll('.support__section-main');
        // remove visibilty of all content elements 
        contentSections.forEach(function(item){
            item.classList.remove('is-visible');
        });
    document.querySelector('.support__sidebar').classList.remove('is-visible');
    supportMessagesEl.classList.remove('is-hidden');

    // show msg delay
    supportMessagesEl.textContent = "Please wait. loading search results";
    await delay(2000);

    // display div 
    resultsWrapper.classList.toggle('is-visible');
    supportMessagesEl.classList.add('is-hidden');
    asideWrapperEl.classList.add('is-visible');

    // add search results title
    let resultsTitle = document.createElement('h2');
    if (resultsWrapper.querySelector('h2')) {
        let existingEl = resultsWrapper.querySelector('h2');
        existingEl.textContent = `Search results for "${queryTerm}"`;
    } else {
        resultsTitle.textContent = `Search results for "${queryTerm}"`;
        resultsWrapper.insertAdjacentElement('beforeend', resultsTitle);
    }

    // create the search result div
    let resultsContainerEl = document.createElement('div');
    resultsContainerEl.setAttribute('class', 'results__container');

    resultsArr.forEach( function(article){

        // links creation
        let articleLinkEl = document.createElement('a');

        let articleSnippet = document.createElement('div');
        let articleSnippetTitle = document.createElement('h2');
        let articleSnippetContent = document.createElement('p');

        articleLinkEl.textContent = article.title;
        articleLinkEl.setAttribute('href', `#${article.id}`);
        articleLinkEl.setAttribute('data-article-id', article.id);
        resultsContainerEl.insertAdjacentElement('beforeend', articleLinkEl);
        if (resultsWrapper.querySelector('.results__container')) {
            let existingEl = resultsWrapper.querySelector('.results__container');
            existingEl.remove();
        }
        resultsWrapper.insertAdjacentElement('beforeend', resultsContainerEl);
        /*
        for (let item in article) {
            console.log(article[item].result_type);
        }
        */
    }); 
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// nav links
document.addEventListener('click', function(e){
    if (e.target.matches('[data-section-target]')) {
        e.preventDefault();
        let allLinks = document.querySelectorAll('[data-section-target]');
        allLinks.forEach(function(link){
            link.classList.remove('active');
        });
        e.target.classList.add('active');
        let targetAtt = e.target.dataset.sectionTarget;
        let targetDiv = document.querySelector(targetAtt);

        supportSectionEls.forEach(function(item){
            item.classList.remove('is-visible');
        });
        targetDiv.classList.add('is-visible');

        // choose a category 
        if (e.target.closest('.support__categories')) {
            let asideEl = document.querySelector('.support__sidebar');
            asideEl.classList.add('is-visible');
            document.querySelector('.support__categories').classList.remove('is-visible');
        }
        
    }
    if (e.target.matches('[data-show-all]')) {
        e.preventDefault();
        let targetAtt = e.target.getAttribute('href');
        let categoryContentEl = e.target.closest('.category__content');
        let parentSectionEl = categoryContentEl.closest('.support__content--rendered');
        let targetDiv = document.querySelector(targetAtt);
        let elementsToHide = categoryContentEl.querySelectorAll('div:not(.category__all)');

        // show content
        targetDiv.classList.add('is-visible');
        // hide header from section
        parentSectionEl.classList.add('hide-elements');

        // hide intro sections
        elementsToHide.forEach(function(element){
            element.classList.add('is-hidden');
        });
    }
    if (e.target.matches('[data-show-back]')) {

        e.preventDefault();
        let categoryContentEl = e.target.closest('.support__content--rendered');
        let elementsToShow = categoryContentEl.querySelectorAll('.category__section-faq, .category__section-walk');
        let elementsToHide = categoryContentEl.querySelectorAll('.category__all,.article__container');

        categoryContentEl.classList.remove('hide-elements');
        elementsToShow.forEach(function(element){
            element.classList.remove('is-hidden');
        });
        elementsToHide.forEach(function(element){
            element.classList.remove('is-visible');
        });
    }
    if (e.target.matches('[data-show-section]')) {
        e.preventDefault();
        let targetElId = e.target.getAttribute('href');
        let targetEl = document.querySelector(targetElId);
        let parentSectionEl = targetEl.closest('.support__content--rendered');
        let elementsToHide = parentSectionEl.querySelectorAll('div:not(.category__all)');
        let allElements = parentSectionEl.querySelectorAll('.category__all');

        // remove all visible class for section all articles
        allElements.forEach(function(item){
            item.classList.remove('is-visible');
        });
        targetEl.classList.add('is-visible');
        parentSectionEl.classList.add('hide-elements');
        elementsToHide.forEach(function(element){
            element.classList.add('is-hidden');
        });
    }
    if (e.target.matches('[data-categories]')) {
        e.preventDefault();
        let elementsTotoggle = document.querySelectorAll('.support__sidebar, .support__content--rendered');
        elementsTotoggle.forEach(function(element){
            element.classList.remove('is-visible');
        });
        document.querySelector('.support__categories').classList.add('is-visible');
    }
});

// set active class for first link on aside sidebar
(function initAside(){
    let asideEl = document.querySelector('.support__sidebar');
    let allLinksEl = asideEl.querySelectorAll('a[data-section-target]');
    allLinksEl[1].classList.add('active');
})();

// sections fetch 
async function getSectionArticles(sectionId, el, pageItems ) {
    let id = parseInt(sectionId);
    let items = parseInt(pageItems);
    let fetchSection = await fetch(`https://davincivaporizer.zendesk.com/api/v2/help_center/en-us/sections/${id}/articles?` + new URLSearchParams({ per_page: items }))
        .catch(function(error){
            console.error(`${error}`);
        })
    ;
    let resultJson = await fetchSection.json();
    // here the main object returns a other array of articles object
    
    let articlesArr = await resultJson.articles;
    articlesArr.forEach(function(article){
        //console.table(article.id, article.url, article.body);
        let elTitle = el.querySelector('h3');
        let articleLinkEl = document.createElement('a');
        articleLinkEl.textContent = article.title;
        articleLinkEl.setAttribute('href', `#article-${article.id}`);
        articleLinkEl.setAttribute('data-article-id', article.id);
        elTitle.insertAdjacentElement('afterend', articleLinkEl);
    })

}
let sectionsEls = document.querySelectorAll('[data-section-id]');

// made it an iife
async function loopSectionsArticles() {
    sectionsEls.forEach( async function(item) {
        // console.log(item.dataset.sectionId);
            if ( item.dataset.articlesLimit && item.dataset.articlesLimit > 1) {
                await getSectionArticles(item.dataset.sectionId, item, item.dataset.articlesLimit);
            } else {
                await getSectionArticles(item.dataset.sectionId, item, 100);
            }
        
    });
}

loopSectionsArticles();

async function getSingleArticle(id, element) {
    let articleID = parseInt(id);
    const articleFetch = await fetch(`https://davincivaporizer.zendesk.com/api/v2/help_center/en-us/articles/` + articleID);
    const articleJson = await articleFetch.json();

    element.textContent = "";
    
    let titleArticle = document.createElement('h2');
    let bodyArticle = document.createElement('div');
    let linkBack = document.createElement('a');
    let bodyResults = articleJson.article.body;
    let parseArticleBody = ConvertStringToHTML(bodyResults);

    titleArticle.textContent = articleJson.article.title;
    bodyArticle.setAttribute('class', 'article__content');
    bodyArticle.insertAdjacentElement('beforeend', parseArticleBody);
    linkBack.textContent = 'Back';
    linkBack.setAttribute('data-show-back','');
    linkBack.setAttribute('href','#');
    // fragment.insertAdjacentElement('beforeend', titleArticle);
    // fragment.insertAdjacentElement('beforeend', bodyArticle);

    element.insertAdjacentElement('beforeend', titleArticle);
    element.insertAdjacentElement('beforeend', bodyArticle);
    element.insertAdjacentElement('beforeend', linkBack);
   // console.log(element);
    //console.log(bodyArticle);
}
let testEl = document.querySelector('#article__container');

// helper function to convert string 
let ConvertStringToHTML = function (str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
};
/*
getSingleArticle(360009372673, testEl);
*/

window.addEventListener('click', async function(event){
    if (event.target.matches('[data-article-id]')) {
        let itemId = event.target.dataset.articleId;
        let itemParent = event.target.closest('.support__content--rendered');
        let elementsToHide = itemParent.querySelectorAll('.category__section-faq, .category__section-walk');
        let elementsToRemove = itemParent.querySelectorAll('.category__all');
        let articleContainer = itemParent.querySelector('.article__container');

        await getSingleArticle(itemId, articleContainer);
        articleContainer.classList.add('is-visible');
        elementsToHide.forEach(function(item){
            item.classList.add('is-hidden');
        });
        elementsToRemove.forEach(function(item){
            item.classList.remove('is-visible');
        });

    }
});

function assignActive() {
    let mainSection = document.querySelector('.support__content-wrapper');
    let isActive = mainSection.querySelector('.support__section-main.is-visible');

    console.log(isActive);
}

assignActive();